

    import {Component, Vue} from 'vue-property-decorator'
    import 'umy-ui/lib/theme-chalk/index.css'
    import {ElForm} from "element-ui/types/form";
    import SalaryUpdate from "./salary-template-add-or-update"
    import SalaryBatchUpdate from "./salary-batch-update"
    import BatchIn from "./bacth-inhistory"

    @Component({
        name: 'contractinfoaa',
        components: {
            SalaryUpdate,
            BatchIn,
            SalaryBatchUpdate
        }
    })
    export default class contractinfoaa extends Vue {
		salaryMonth =''
        dataList = []
        loading = false
        menuVisible = false
        searchForm = {xm: '', username: '', bmid: '', gw: '', sfzhm: '', yhzh: '', newPeople: 0}
        editAllColumnVisible = false
        addOrUpdateVisible = false
        batchAddOrUpdateVisible = false
        batchinVisible = false
        saveVisiable = false
        selectCol = ''
        depts = []
        dataListSelections = []
        deptdisable = false
        editColForm = {colValue: ''}
        selectRow = {}
        peopleNumber = 0
        tableHeight = 700
        monthMonent = this.$moment().startOf('month');
        notedit: number[] = [2, 3, 4, 5, 6, 7, 8, 17, 18, 19, 20, 21, 22, 23, 24, 25, 30, 31, 37, 38, 39, 40, 43, 44, 46, 58, 59, 60, 61]
        salaryStatus: { id: string, month: string, status: number, type: number } = {
            id: '',
            month: '',
            status: 0,
            type: 0
        }
        showInit = false
        canEditAll: string[] = [
            'gwGz', 'khj', 'jt1', 'jt2', 'jt3', 'zbjt', 'gwjts', 'djhxjt', 'jj', 'gwf', 'yicixing', 'zwjt', 'ft', 'qt1', 'qt2', 'dszn', 'ghf', 'kj', 'dk', 'zdgzbz', 'jkzk', 'sbjs', 'gjjjs', 'jbjcfy']
        validateNumber = ({cellValue, rule}: { cellValue: string, rule: any }) => {
            console.log('1111111111111')
            if (cellValue) {
                var patrn = /^\d+(\.\d+)?$/;
                if (!patrn.exec(cellValue)) {
                    return new Error('请填写数字')
                }
            }
        }
        validateNumber2 = (rule: any, value: any, callback: (s?: any) => never) => {
            var patrn = /^\d+(\.\d+)?$/;
            if (!patrn.exec(value)) {
                callback(new Error('请填写数字'))
            } else {
                callback()
            }
        }
        $refs!: { plTable: HTMLElement, editColForm: ElForm, addOrUpdate: any }
        rules = {
            gwGz: [
                {required: true, message: '岗位工资必填'}
            ],
            sbjs: [
                {required: true, message: '社保缴费基数必填'}
            ],
            gjjjs: [
                {required: true, message: '公积金缴费基数必填'}
            ],
            zdgzbz: [
                {required: true, message: '最低工资标准必填'}
            ]
        }
        editColRules = {
            colValue: [
                {validator: this.validateNumber2, trigger: 'blur'}
            ]
        }
        editColumnRule = {}

        created() {

        }

        mounted() {
            let boundingClientRectTop = this.$refs.plTable.$el.getBoundingClientRect().top ? this.$refs.plTable.$el.getBoundingClientRect().top : 0
            let expolerHeight = window.innerHeight ? window.innerHeight : 0
            this.tableHeight = window.innerHeight - boundingClientRectTop
            this.findMaxSalaryStatus()
            // window.salaryTable = this.$refs.plTable
            this.getDepts()
            // this.dataLists = salarydata

        }

        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser', {
                params: {
                    userid: this.$store.getters.username
                }

            }).then(res => {
                that.depts = res.data
                if (this.depts && this.depts[0]) {

                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if (zzdyqc) {
                        if (zzdyqc != this.CONST_ZN_BM) {
                            var zw = this.$store.getters.user.zw;

                            if (zw) {
                                if (zw == '01' || zw == '02' || zw == '03') {
                                    this.searchForm.bmid = that.depts[0].bmid
                                    this.deptdisable = true

                                }

                            }
                        }

                    }

                }
            })
        }

        createNew() {
            let month = this.$moment(this.salaryStatus.month, 'YYYY-MM').add(1, 'months').format('YYYY-MM')
            this.initLastMonthSalary(month)
        }

        findMaxSalaryStatus() {
            this.$request({
                url: '/bjba/salaryStatus/findMaxDateSalarySatus',
                params: {type: 2},
                method: 'get'
            }).then(res => {
                // console.log(res.data.data)
                this.salaryStatus = res.data.data
                if (this.salaryStatus && this.salaryStatus.status !== 0) {
                    this.getSalaryInData()
                } else {
                    this.showInit = true
                }
            })
        }

        firstInit() {
            this.initLastMonthSalary()
        }

        initLastMonthSalary(month?: string) {
            let date = ''
            if (month) date = month
            else date = this.$moment().format('YYYY-MM');
            this.$request({
                method: 'post',
                url: '/bjba/salary/initSalaryData',
                params: {type: 2, month: date}
            }).then(res => {
                if (res.data.code == 200) {
                    this.salaryStatus = res.data.data
                    if (this.salaryStatus && this.salaryStatus.status == 0) this.showInit = true
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 1500
                    })
                }
            }).catch(error => {

            })
        }

        showEditAllColumnDialog() {
            this.editAllColumnVisible = true
            this.$nextTick(() => {
                this.$refs.editColForm.resetFields()
            })
        }

        updateColValue() {
            /*this.$refs.editColForm.validate((valid) => {
                console.log(15115155)
                if (valid) {
                    // let {fullData} = this.$refs.plTable.getTableData()
                    // fullData.forEach((item,index,array)=>{
                    // 	item[this.selectCol] = this.editColForm.colValue
                    // })
                    // this.editAllColumnVisible = false
                    this.$request({
                        url: '/bjba/salary/changeCol',
                        params:{salaryStatusId:this.salaryStatus.id,
                        field:this.selectCol,value:this.editColForm.colValue,type:0},
                        method: 'post'
                    }).then(res => {
                        this.editAllColumnVisible = false
                        this.getSalaryInData()
                    })
                }
            })*/
            this.$request({
                url: '/bjba/salary/changeCol',
                params: {
                    salaryStatusId: this.salaryStatus.id,
                    field: this.selectCol, value: this.editColForm.colValue, type: 0
                },
                method: 'post'
            }).then(res => {
                this.editAllColumnVisible = false
                this.getSalaryInData()
            })
        }

        getSalaryInData() {
            this.loading = true
            this.$request({
                method: 'get',
                url: '/bjba/salary/getSalaryInDataHistory',
                params: {
                    type: 2,
                    // salaryStatusId: this.salaryStatus.id,
                    month: this.salaryMonth,
                    xm: this.searchForm.xm,
                    username: this.searchForm.username,
                    bmid: this.searchForm.bmid,
                    gw: this.searchForm.gw,
                    sfzhm: this.searchForm.sfzhm,
                    yhzh: this.searchForm.yhzh
                    ,
                    newPeople: this.searchForm.newPeople
                }
            }).then(res => {
                this.loading = false
                if (res.data.data) this.peopleNumber = res.data.data.length
                else this.peopleNumber = 0
                // this.dataList = res.data.data
                this.$refs.plTable.reloadData(res.data.data)
                this.dataListSelections = []
            }).catch(error => {
                this.loading = false
            })
        }

        cellStyle({row, column, rowIndex, columnIndex}) {
            if (this.notedit.includes(columnIndex)) return {backgroundColor: "#d9ecff"}
        }

        editClosed({row, rowIndex, $rowIndex, column, columnIndex, $columnIndex}: any) {
            // console.log(row,rowIndex,$rowIndex, column, columnIndex, $columnIndex)
            /*this.$refs.plTable.validate(row).then(data => {
                if (data) {
                    let masStr = ''
                    Object.values(data).forEach(errList => {
                        console.log(errList)
                        errList.forEach(params => {
                            let { rule } = params
                            this.$message.error({
                                showClose: true,
                                message: rule.message
                            })
                        })
                    })
                }  else {
                    this.$request({
                        url: '/bjba/salary/changeHtsalaryData',
                        data: row,
                        params:{month:this.salaryStatus.month},
                        method: 'post'
                    }).then(res => {
                        console.log(res.data.data)
                        // this.dataLists[rowIndex] = res.data.data
                        this.$refs.plTable.reloadRow(row, res.data.data, null)
                    })
                }
            })*/
            this.$request({
                url: '/bjba/salary/changeSchoolSalaryData',
                data: row,
                params: {month: this.salaryStatus.month},
                method: 'post'
            }).then(res => {
                console.log(res.data.data)
                // this.dataLists[rowIndex] = res.data.data
                this.$refs.plTable.reloadRow(row, res.data.data, null)
            })
        }

        changeLxly(checked: number, row: any) {
            /*this.$refs.plTable.validate(row).then(data => {
                if (data) {
                    let masStr = ''
                    Object.values(data).forEach(errList => {
                        console.log(errList)
                        errList.forEach(params => {
                            let { rule } = params
                            this.$message.error({
                                showClose: true,
                                message: rule.message
                            })
                        })
                    })
                }  else {
                    this.$request({
                        url: '/bjba/salary/changeHtsalaryData',
                        data: row,
                        params:{month:this.salaryStatus.month},
                        method: 'post'
                    }).then(res => {
                        console.log(res.data.data)
                        // this.dataLists[rowIndex] = res.data.data
                        this.$refs.plTable.reloadRow(row, res.data.data, null)
                    })
                }
            })*/
            this.$request({
                url: '/bjba/salary/changeSchoolSalaryData',
                data: row,
                params: {month: this.salaryStatus.month},
                method: 'post'
            }).then(res => {
                // console.log(res.data.data)
                // this.dataLists[rowIndex] = res.data.data
                this.$refs.plTable.reloadRow(row, res.data.data, null)
            })
        }

        headerContextMenu(column: any, event: any) {
            // console.log(column.property)
            if (this.canEditAll.includes(column.property) && this.salaryStatus.status !== 2) {
                this.menuVisible = false // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
                this.menuVisible = true // 显示模态窗口，跳出自定义菜单栏
                event.preventDefault() //关闭浏览器右键默认事件
                var menu = document.querySelector('.menu')
                this.styleMenu(menu)
                this.selectCol = column.property

            }
        }

        selectionChange(val: Array) {
            this.dataListSelections = val
        }

        rowClick(row: any, column: any, event: any) {
            this.selectRow = row
        }

        updateRow() {
            if (this.selectRow && this.selectRow.salaryLogId) {
                this.addOrUpdateVisible = true
                let row0 = {...this.selectRow}
                // console.log(row0)
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(row0)
                })
            } else {
                this.$message.warning({
                    showClose: true,
                    message: "请选择行"
                })
            }
        }

        batchUpdateRow() {
            // debugger
            if (this.dataListSelections && this.dataListSelections.length > 0) {
                this.batchAddOrUpdateVisible = true
                // let data = {salaryStatusId:this.salaryStatus.id,type:0}
                let userids = this.dataListSelections.map(item => {
                    return item.userId
                })
                this.$nextTick(() => {
                    this.$refs.batchUpdate.init(userids, this.salaryStatus.id, 2)
                })
            } else {
                this.$message.warning({
                    showClose: true,
                    message: "请勾选行"
                })
            }
        }

        showSaveData() {
            this.saveVisiable = true
        }

        saveData() {
            this.$refs.plTable.validate(true).then(data => {
                if (data) {
                    let masStr = ''
                    Object.values(data).forEach(errList => {
                        console.log(errList)
                        errList.forEach(params => {
                            let {rule, row} = params
                            this.$message.error({
                                showClose: true,
                                message: `${row.userName} ${rule.message}`
                            })
                        })
                    })
                } else {

                    this.$request({
                        url: '/bjba/salaryStatus/save',
                        data: {
                            id: this.salaryStatus.id, month: this.salaryStatus.month, status: 2,
                            type: this.salaryStatus.type
                        },
                        method: 'post'
                    }).then(res => {
                        let data = res.data
                        if (data && data.code === 200) {
                            this.$message({
                                message: '保存',
                                type: 'success',
                                duration: 1500
                            })
                            this.salaryStatus.status = 2
                            this.saveVisiable = false
                            // this.$emit('refreshDataList')
                            this.findMaxSalaryStatus()
                        } else if (data && data.code === 500) {
                            this.$message({
                                message: data.message,
                                type: 'error',
                                duration: 1500
                            })
                        }
                    })
                }
            })
            // this.salaryStatus.status = 2
            // this.$request({
            // 	url: '/bjba/salaryStatus/save',
            // 	data: this.salaryStatus,
            // 	method: 'post'
            // }).then(res => {
            // 	let data = res.data
            // 	if (data && data.code === 200) {
            // 		this.$message({
            // 			message: '保存',
            // 			type: 'success',
            // 			duration: 1500
            // 		})
            // 		this.saveVisiable = false
            // 		// this.$emit('refreshDataList')
            // 		this.findMaxSalaryStatus()
            // 	} else if(data && data.code === 500) {
            // 		this.$message({
            // 			message: data.message,
            // 			type: 'error',
            // 			duration: 1500
            // 		})
            // 	}
            // })
        }

        exportExcel() {

            var viewUrl = this.$request.defaults.baseURL + '/bjba/salary/getSalaryInExcel?type= 2&salaryStatusId=' + this.salaryStatus.id + '&access_token=' + this.$store.getters.token
            window.open(viewUrl)
        }

        batchin() {
            this.batchinVisible = true
            let salaryInfo = {statusId: this.salaryStatus.id, type: 2}
            this.$nextTick(() => {
                this.$refs.batchin.init(salaryInfo)
            })
        }

        editRow(row: any) {
            /*this.$refs.plTable.validate(row).then(data => {
                if (data) {
                    let masStr = ''
                    Object.values(data).forEach(errList => {
                        console.log(errList)
                        errList.forEach(params => {
                            let { rule } = params
                            this.$message.error({
                                showClose: true,
                                message: rule.message
                            })
                        })
                    })
                }  else {
                    this.$request({
                        url: '/bjba/salary/changeHtsalaryData',
                        data: row,
                        params:{month:this.salaryStatus.month},
                        method: 'post'
                    }).then(res => {
                        console.log(res.data.data)
                        // this.dataLists[rowIndex] = res.data.data
                        this.$refs.plTable.reloadRow(this.selectRow, res.data.data, null)
                    })
                }
            })*/
            this.$request({
                url: '/bjba/salary/changeSchoolSalaryData',
                data: row,
                params: {month: this.salaryStatus.month},
                method: 'post'
            }).then(res => {
                console.log(res.data.data)
                // this.dataLists[rowIndex] = res.data.data
                this.$refs.plTable.reloadRow(this.selectRow, res.data.data, null)
            })
        }

        activeMethod({row, rowIndex, column, columnIndex}: any) {
            if (this.salaryStatus.status === 2) return false
            else return true
        }

        styleMenu(menu: any) {
            if (event.clientX > 1800) {
                menu.style.left = event.clientX - 100 + 'px'
            } else {
                menu.style.left = event.clientX + 1 + 'px'
            }
            document.addEventListener('click', this.foo) // 给整个document新增监听鼠标事件，点击任何位置执行foo方法
            if (event.clientY > 700) {
                menu.style.top = event.clientY - 30 + 'px'
            } else {
                menu.style.top = event.clientY - 10 + 'px'
            }
        }

        foo() {
            // 取消鼠标监听事件 菜单栏
            this.menuVisible = false
            document.removeEventListener('click', this.foo) // 关掉监听，
        }

        cellClick(row, column, cell, event) {
            if (this.$refs.plTable.isActiveByRow(row)) {
                this.$refs.plTable.clearActived()
            }

        }

        // 点击编辑按钮，激活行状态-> 为编辑状态
        editRowEvent(row: any) {
            this.$refs.plTable.setActiveRow(row)
        }

        // 点击保存
        saveEvent(row: any) {
            // 判断是否发生改变
            console.log(this.$refs.plxTable.isUpdateByRow(row))
            // 你也可以不使用这个判断，我是给示例，没做个性化需求
            if (this.$refs.plxTable.isUpdateByRow(row)) {
                // ...保存相关的逻辑（后端的呀，或者前端的呀）
                // 清除表格激活状态
                this.$refs.plxTable.clearActived().then(() => {
                    // 局部保存，并将行数据恢复到初始状态（如果 第二个参数record 为空则不改动行数据，只恢复状态）
                    // 你不执行这个reloadRow，代表下次进来你上面的这个if还是会执行，不然下次点击保存，还是保存成功哦！状态没改变哦
                    this.$refs.plxTable.reloadRow(row, null, null)
                    // 如果，假如你保存了后端给你个当前行的row，那么你需要赋值给表格行呢，你就需要把后端给你的row填到第二个参数位置
                    // this.$refs.plxTable.reloadRow(row, 后端的row, null)
                    // 第三个参数呢就是只改变当前行中的call单个单元格。第三个参数是row中的字段名（field属性的值）
                })
                this.$message({
                    message: '恭喜你，保存成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: '保存失败，你没改变当前行的数据',
                    type: 'error'
                });
            }
        }

        closedInput(row: any) {
            if (this.$refs.plTable.isActiveByRow(row)) {
                this.$refs.plTable.clearActived()
            }
        }

        get isSaved() {
            return this.salaryStatus && this.salaryStatus.status == 2
        }

        get canCreate() {
            return this.salaryStatus && this.$moment(this.salaryStatus.month, 'YYYY-MM').isBefore(this.monthMonent)
        }
    }
